export default {
  /* 按鈕 */
  bt: {
    export: "导出﹙每次最多 500 行﹚",
    createSingleDraft: "建立单一草稿",
    batchAdd: "批量新增",
    editEmailTemplate: "编辑电邮模版",
    cancel: "取消",
    confirmAdd: "新增",
    retry: "重试",
    saveSettings: "储存设定",
    saving: "储存中..."
  },
  /* 公用字段或工具函數字段 */
  common: {
    businessType: "业务",
    businessTypePlaceholder: "请选择业务",
    queryTime: "查询时间",
    businessTypeGM: "GMX",
    businessTypeCX: "CXX",
    businessTypeGMCX: "GMCX",
    sequence: "序号",
    startTime:"开始时间",
    endTime:"结束时间",
    creator:"创建人",
    updater:"更新人",
    createTime:"创建时间",
    updateTime:"更新时间",
    phone:"手机号",
    email:"邮箱",
    idNumber:"身份证号码",
    status:"状态",
    remark:"备注"
  },
  /* 公用訊息和提示 */
  msg: {
    apiError: "(状态码 {status}) {message}",
    networkError: "无法连接到伺服器，请检查您的网路连线。",
    unknownError: "发生未知的错误。",
    resetSuccess: "所有栏位和筛选条件已重设。"
  },
  listCommon: {
    pno: "PNO",
    pnoPlaceholder: "请输入单一或多个 PNO，以 ',' 或 ', ' 分隔",
    templateType: "模板类型 (单一新增用)",
    templateTypePlaceholder: "请选择",
    accountNo: "帐号",
    proposalNo: "提案号",
    paidAmount: "实付金额",
    gatewayName: "网关名称",
    name: "姓名",
    currency: "货币",
    emailSentTime: "邮件发送时间",
    proposalStatus: "提案状态",
    lastUpdateTime: "最后更新时间",
    depositDiscrepancyProcessTime: "掉单处理时间"
  },
  listMsg: {
    pnoRequiredForSingle: "单一建立草稿时，PNO 栏位不可为空。",
    pnoRequiredForBatch: "批量新增时，PNO 栏位不可为空。",
    pnoBatchLimit: "批量新增的 PNO 数量不可超过 50 个。",
    batchAddConfirmTitle: "批量新增确认",
    classifying: "正在分类处理中...",
    gmPnos: "GM 类型 PNO",
    cxPnos: "CX 类型 PNO",
    invalidPnos: "以下是无效、已存在、已取消或已审批 PNO，不会用来建立草稿",
    invalidPnoError: "无效、已存在、已取消或已审批 PNO！！！",
    getTemplateFailed: "无法获取已填充的电邮模版。",
    classifyFailed: "分类处理失败: {error}",
    getTemplateError: "获取 {templateType} 模版时出错: {error}",
    extensionAPIError: "无法侦测到 Google Chrome 扩充功能通讯 API。",
    extensionIdError: "无效的 Google Chrome 扩充功能 ID",
    extensionCommError: "与扩充功能通讯失败：{message}",
    extensionOpError: "扩充功能操作失败: {error}",
    extensionSuccess: "请求已发送至扩充功能！",
    extensionOpSuccess: "扩充功能已成功执行操作：{action}",
    extensionOnlyMessage: "此功能仅在 Google Chrome 浏览器中且已安装相应扩充功能时可用。",
    exportListTitle: "存款掉单邮件发送列表",
    editEmailTemplateTitle: "编辑电邮模版",
    loadingTemplate: "正在载入模版...",
    loadTemplateFailed: "载入模版失败:",
    templateInfoPart1: "当您在建立草稿时，以下模版将用于自动填入。您可以使用",
    templateInfoPart2: "作为占位符。",
    templateSectionGM: "GM 类型模板",
    templateSectionCX: "CX 类型模板",
    recipientTemplate: "收件人模板 ({type}):",
    subjectTemplate: "主旨模板 ({type}):",
    bodyTemplate: "内文模板 ({type}):",
    recipientPlaceholder: "例如：{example}",
    subjectPlaceholderGM: "例如：GM 存款掉单事项 - PNO: {pno}",
    subjectPlaceholderCX: "例如：CX 存款掉单事项 - PNO: {pno}",
    bodyPlaceholderGM: "GM 相关内文模板...",
    bodyPlaceholderCX: "CX 相关内文模板...",
    saveSuccess: "电邮模版已成功更新！",
    saveError: "储存失败: {error}"
  },
  statsCommon: {
    statsDate: "日期",
    statsSize: "数量",
    statsSmallAmountTransfer: "小额定额 1 万人民币以下",
    statsLargeAmountTransfer: "大额转账 1 万人民币以上",
    statsAlipay: "支付宝",
    statsUSDT: "USDT",
    statsDigitalRMB: "数字人民币",
    statsCloudQuickPass: "云闪付",
    statsCardCode: "卡密",
    statsWeChat: "微信",
    statsYunPayTransfer: "云付转账",
    statsOthers: "其他",
    statsDiscrepancyAmountCNY: "掉单金额 CNY",
    statsDiscrepancyAmountUSD: "掉单金额 USD",
    statsDiscrepancyAmountOthers: "掉单金额﹙其他﹚",
    statsTotalProcessingTime: "总处理时间",
    statsAverageProcessingTime: "平均处理时间"
  },
  statsMsg: {
    exportListTitle: "掉单统计"
  }
};
